
export default {
  name: "DropDownLevel",

  data: function () {
    return {
      activeItem: null
    }
  },

  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    level: {
      type: Number,
      default: 0
    }
  },

  computed: {
    itemsColumn: function () {
      return Math.ceil(this.items.length / 8)
    }
  },

  components: {
    DropDownLevel: () => import("./_DropDownLevel.vue")
  },

  methods: {
    openItem: function (item) {
      if ((item?.children || []).length <= 0) {
        this.activeItem = null;
        return
      }
      this.activeItem = item;
    },
    routeItem: function (item) {
      this.$router.push(`/${item.path}`);
      this.close();
    },

    close: function () {
      this.activeItem = null;
      this.$emit("close");
    },
  }
}
